export default {
  methods: {
    // DISPATCHES an error event to be handled by listeners (e.g., in EventsDefinitions.js)
    // err: the error object (should contain a 'response' property)
    // prevent: if true, prevents the default error handling in the listener
    // actionEv: optional callback event name to be dispatched after handling
    setError(err, prevent, actionEv) {
      // If error is missing or is a server error (status >= 500), use a default error object
      if (!err || !err.response || (err.response && err.response.status >= 500)) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      }
      // Ensure err.response exists before accessing its properties
      const errorStatus = err.response?.status || "500";
      // Dispatch a custom event with error details
      document.dispatchEvent(
        new CustomEvent("error-" + errorStatus, {
          detail: {
            // If prevent is true, the listener will skip default error handling
            preventDefault: prevent || false,
            // Optional callback event to be triggered by the listener
            callbackEvent: actionEv,
            // Error response data
            data: err.response || "No response",
          },
        }),
      );
    },
  },
};
